import React from 'react';

import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import '../../assets/MyStyles.scss';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const styles = theme => ({
  indicator: {
    backgroundColor: '#0000FF',
  },
})

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function SimpleTabs(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const request = props.request;
  const bodyDisabled = request.body != undefined ? false : true;
  const queryDisabled = request.query != undefined ? false : true;


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" elevation={0}>
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" className="ib-bg" centered
          TabIndicatorProps={{style: {background:'#0c3356'}}}
          >

          <Tab label="Headers" {...a11yProps(0)} />
          <Tab label="Body" {...a11yProps(1)} disabled={bodyDisabled} />
          <Tab label="Query" {...a11yProps(2)} disabled={queryDisabled} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        {request.headers != undefined ? <pre> {JSON.stringify(request.headers, null, 2)} </pre> : <p>No headers</p>}
      </TabPanel>
      <TabPanel value={value} index={1}>
        {request.body != undefined ? <pre> {JSON.stringify(request.body, null, 2)} </pre> : <p>Body is empty</p>}
      </TabPanel>
      <TabPanel value={value} index={2}>
        {request.query != undefined ? <pre> {JSON.stringify(request.query, null, 2)} </pre> : <p>Body is empty</p>}
      </TabPanel>
    </div>
  );
}
